import type {
  CenterOfInfluenceRepPreferredContactMethod,
  CenterOfInfluenceRepSpecialty,
  ProfessionalRelationshipRole,
} from '@savvy/constants/generated/gql-enums';

export const SPECIALTY_OPTIONS: readonly CenterOfInfluenceRepSpecialty[] = [
  'coi',
  'tax',
  'estate',
  'legal',
  'insurance',
  'mortgage',
  'other',
];

export const SPECIALTY_LABELS: Record<CenterOfInfluenceRepSpecialty, string> = {
  coi: 'Center of influence',
  tax: 'Tax',
  estate: 'Estate',
  legal: 'Legal',
  insurance: 'Insurance',
  mortgage: 'Mortgage',
  other: 'Other',
};

export const PREFERRED_CONTACT_METHOD_OPTIONS: readonly CenterOfInfluenceRepPreferredContactMethod[] = [
  'email',
  'phone',
  'mobile',
  'other',
];

export const PREFERRED_CONTACT_METHOD_LABELS: Record<CenterOfInfluenceRepPreferredContactMethod, string> = {
  email: 'Email',
  phone: 'Phone',
  mobile: 'Mobile',
  other: 'Other',
};

export const ROLE_OPTIONS: readonly ProfessionalRelationshipRole[] = [
  'accountant',
  'attorney',
  'cpa',
  'financial_planner',
  'insurance_agent',
  'estate_planner',
  'other',
];

export const ROLE_LABELS: Record<ProfessionalRelationshipRole, string> = {
  accountant: 'Accountant',
  attorney: 'Attorney',
  cpa: 'CPA',
  financial_planner: 'Financial planner',
  insurance_agent: 'Insurance agent',
  estate_planner: 'Estate planner',
  other: 'Other',
};

// Suggests a default `role` when linking a professional contact elsewhere (e.g. to a retirement
// plan), based on their specialty tags here. Priority follows SPECIALTY_OPTIONS order when a
// contact has more than one tag; unmapped specialties (coi, mortgage) suggest nothing.
export const SPECIALTY_TO_ROLE: Partial<Record<CenterOfInfluenceRepSpecialty, ProfessionalRelationshipRole>> = {
  tax: 'accountant',
  estate: 'estate_planner',
  legal: 'attorney',
  insurance: 'insurance_agent',
  other: 'other',
};

export function suggestRoleFromSpecialties(
  specialties: readonly CenterOfInfluenceRepSpecialty[],
): ProfessionalRelationshipRole | null {
  for (const specialty of SPECIALTY_OPTIONS) {
    if (!specialties.includes(specialty)) continue;
    const role = SPECIALTY_TO_ROLE[specialty];
    if (role !== undefined) return role;
  }
  return null;
}

export const ALL_BUSINESSES_TAB = 'all-businesses';

export const PROFESSIONAL_CONTACTS_TAB_VALUES = [
  'all-contacts',
  ALL_BUSINESSES_TAB,
  'contact-web',
  'referrals',
] as const;
